import React, { useEffect, useRef, useState } from "react";
import { pill, GLASS, FONT, SAFE_TOP } from "../kota/ui";

// Potongan UI bersama semua mini game: HUD (timer melingkar · poin · penghitung tambahan), pil petunjuk, hitung mundur.
export function useCountdown(durasi, onHabis) {
  const [sisa, setSisa] = useState(durasi);
  const cb = useRef(onHabis); cb.current = onHabis;
  useEffect(() => {
    const t = setInterval(() => setSisa(s => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, []);
  useEffect(() => { if (sisa === 0) cb.current(); }, [sisa]);
  return sisa;
}

// extra: [[Icon, warna, teks], ...]
export function Hud({ sisa, durasi, poin, extra = [], atas = 66 }) {
  const pct = sisa / durasi, R = 15, L = 2 * Math.PI * R;
  return (
    <div data-testid="kerja-hud" style={{ position: "absolute", left: 0, right: 0, top: `calc(${SAFE_TOP} + ${atas}px)`, display: "flex", justifyContent: "center", pointerEvents: "none", fontFamily: FONT }}>
      <div style={{ ...pill, height: 46, padding: "0 16px 0 8px", gap: 12 }}>
        <span style={{ position: "relative", width: 36, height: 36, display: "grid", placeItems: "center" }}>
          <svg width="36" height="36" viewBox="0 0 36 36" style={{ position: "absolute", inset: 0, transform: "rotate(-90deg)" }}>
            <circle cx="18" cy="18" r={R} stroke="var(--g-inner)" strokeWidth="3" fill="none" />
            <circle cx="18" cy="18" r={R} stroke={pct > .25 ? "#2e9e5b" : "#dc2626"} strokeWidth="3" fill="none" strokeDasharray={L} strokeDashoffset={L * (1 - pct)} strokeLinecap="round" style={{ transition: "stroke-dashoffset 1s linear" }} />
          </svg>
          <b data-testid="kerja-timer" style={{ fontSize: 12.5, fontVariantNumeric: "tabular-nums" }}>{sisa}</b>
        </span>
        <span><b data-testid="kerja-poin" style={{ fontSize: 16, fontWeight: 800 }}>{poin}</b> <span style={{ fontSize: 11, color: GLASS.sub }}>poin</span></span>
        {extra.map(([Icon, warna, teks], i) => <span key={i} data-testid={`kerja-hud-${i}`} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 12.5, fontWeight: 700 }}><Icon size={14} color={warna} /> {teks}</span>)}
      </div>
    </div>
  );
}

export function Petunjuk({ children }) {
  return (
    <div data-testid="kerja-petunjuk" style={{ position: "absolute", left: 0, right: 0, bottom: "13%", display: "flex", justifyContent: "center", pointerEvents: "none", fontFamily: FONT }}>
      <span style={{ ...pill, height: 34, background: "rgba(20,20,20,.72)", color: "#fff", border: 0, fontSize: 12.5 }}>{children}</span>
    </div>
  );
}

// Teks melayang (+1, Panen!, …) yang naik lalu hilang
export function Pop({ x, y, children, warna = "#fff" }) {
  return <b style={{ position: "absolute", left: x, top: y, color: warna, fontSize: 18, fontWeight: 800, textShadow: "0 2px 8px rgba(0,0,0,.35)", animation: "jw-pop .7s ease-out forwards", pointerEvents: "none", fontFamily: FONT, whiteSpace: "nowrap" }}>{children}</b>;
}
export const POP_CSS = `@keyframes jw-pop{0%{transform:translate(-50%,-50%) scale(.8);opacity:1}100%{transform:translate(-50%,-150%) scale(1.15);opacity:0}}`;
